export class CheckItem {
  id: string;
  checked: boolean;
  description: string;
  weight: number;
  start: Date;
  end: Date;
  sortOrder: number;
}